import { render, staticRenderFns } from "./EditContentGroup.vue?vue&type=template&id=c1803828"
import script from "../../services/upload/edit-content-group.js?vue&type=script&lang=js&external"
export * from "../../services/upload/edit-content-group.js?vue&type=script&lang=js&external"
import style0 from "../../assets/css/upload/video-upload.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "../../assets/css/teacher/create-course.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports